module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "cn"
  }, [_vm._v("CHAPTER 1")]), _vm._v(" "), _c('h2', {
    staticClass: "ct"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("BELGIUM: NAKED NEUTRAL")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("As they emerged from the revolutions of 1830, the southern provinces of the Netherlands broke away to form the Kingdom of Belgium in 1831. The nation, whose northern plains had served as a crossroads for invading armies for centuries, lacked good defensive borders."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn-1",
      "id": "fn-1"
    }
  }, [_vm._v("1")])]), _vm._v(" It was ethnically divided between Flemings and Walloons. The French-speaking Walloons, who lived mainly in the southern half of the country, occupied part of the economic heart of the country north of the Maas (Meuse). The Flemings, on the other hand, dwelled in the industrialized northern part of the country.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When the Germans invaded Belgium in 1914, they came face to face with an army dressed in uniforms better suited for the Napoleonic Era. They also encountered the much vaunted, most modern fortresses of Europe designed by military engineer General Henri Brialmont (1821–1903). German general Alfred von Schlieffen formulated a plan to neutralize these fortresses quickly. His successor, Moltke the Younger, was blamed for not concentrating most of the army against Belgium to outflank the French. Liège and Namur held out longer than expected, upsetting the invasion’s timetable. Additional divisions, however, would have made little difference.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Leopold I (1790–1865), Belgian’s first king, wary of Napoleon III’s ambition, had initiated an effort to protect his country’s neutrality. During the Franco-Prussian War, the small Belgian army took up positions on its borders to discourage an invasion. King Leopold II (1835–1909) had expanded the army by 1913. Minister of War Charles de Broqueville (1860–1940)"), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn-2",
      "id": "fn-2"
    }
  }, [_vm._v("2")])]), _vm._v(" increased its size to over 120,000 men, but did not assign first-class troops to the forts.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("General Henri Alexis Brialmont (1821–1903),"), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn-3",
      "id": "fn-3"
    }
  }, [_vm._v("3")])]), _vm._v(" an army engineer since 1841, became the leading figure in the art of fortifications after 1860. He adopted the ideas on fortifications of French general Marc-René de Montalembert (1714–1800) who replaced the enceinte in Vauban-type fortifications with a ring or girdle of polygonal forts."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn-4",
      "id": "fn-4"
    }
  }, [_vm._v("4")])]), _vm._v(" In the late 1840s, the army abandoned the Wellington Barrier"), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn-5",
      "id": "fn-5"
    }
  }, [_vm._v("5")])]), _vm._v(" and began turning Antwerp into an entrenched camp in 1852. The army retained a number the small and old defences between Ghent and Namur and Liège and Dinant. Brialmont abandoned fortifications of the bastion system and turned the entrenched camp of Antwerp into the National Redoubt. In 1859, France became a threat again.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Brialmont’s last construction phase produced Europe’s most modern forts of the 1880s. However, these defences had serious flaws, which General Victor Deguise (1855–1922), Antwerp’s commander during the Great War, wanted to correct."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn-6",
      "id": "fn-6"
    }
  }, [_vm._v("6")])]), _vm._v(" Although Deguise called for greater dispersion of the combat positions in the forts, few modifications were actually carried out at Brialmont’s positions at Liège and Namur. Thus, Brialmont’s forts soon became outdated even after the addition of armoured gun turrets. Failure of the engineers to improve the concrete protection made them highly vulnerable to new heavy artillery developed after the mid-1880s.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f002-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Aerial photo of a section of the Antwerp Ring with plan of Fort Wavre-St. Catherine and Fort Lierre. Also, plans for Redoubts and Half Redoubts of Antwerp.")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After the Franco-Prussian War, Brialmont called for two major fortified bridgeheads on the Meuse. The fortress of Liège would cover ten bridges over the Meuse and dominate two others, while that of Namur would protect three bridges on the Meuse and dominate two others. In between them, the town of Huy controlled two bridges on the Meuse with only one old reinforced fort. Brialmont expected the Germans to reach Antwerp in five days, so he concluded that Liège was the obvious choice for a fortress ring to delay their advance. Namur, on the other hand, offered the best chance to deter a French invasion."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn-10",
      "id": "fn-10"
    }
  }, [_vm._v("10")])]), _vm._v(" The Belgian government did not approve these projects until the late 1880s. In the meantime, Brialmont worked in Romania fortifying Bucharest from 1883 to 1884 and retired from the army. He returned to Romania in 1886."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn-11",
      "id": "fn-11"
    }
  }, [_vm._v("11")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "box-t"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Brialmont’s Antwerp: Europe’s Largest Fortress in 1914")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Between 1860 and 1864, Brialmont razed the old Spanish Wall of Antwerp and built the ‘De Grote Omwalling’ (the Great Rampart) that stretched for about 11km and included inundations 3m to 4m deep. Brialmont created a fortress girdle beyond the enceinte by rebuilding the seven outdated bastioned forts and adding Fort Number 8. The new designs, which followed Montalembert’s polygonal pattern, included a three-storey brick gorge reduit. Armament for these forts consisted of smoothbore 12pdr and 24pdr guns in casemates on platforms. The caponiers received breech-loading rifled cannons designed by Martin von Wahrendorff"), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn-7",
      "id": "fn-7"
    }
  }, [_vm._v("7")])]), _vm._v(" until modern 57mm QF guns replaced them late in the century. Fort Number 3 received a Coles’ turret with two 150mm guns in 1863,"), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn-8",
      "id": "fn-8"
    }
  }, [_vm._v("8")])]), _vm._v(" becoming one of the first forts armed with a gun turret."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn-9",
      "id": "fn-9"
    }
  }, [_vm._v("9")])]), _vm._v(" Early in the twentieth century, seven of the other forts received turrets and the defences between them were beefed up. Forts 1 to 8 covered the south and south-east side of Antwerp and inundations from the Scheldt protected parts of its western and northern sides where only a few forts were added. A defensive dike built in 1870–80 west of Antwerp ran for a few kilometres south of Fort St. Marie on the Scheldt. This fort received an armoured battery, while Fort Perle to the north and Fort St. Philippe were strengthened in 1877–81. Concrete reinforcement was added to the brick walls of Fort Merksem – built in 1871 north of the new city wall – and other old forts in 1911.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("From the 1870s to the 1880s, the army added new forts, pushing the fortress outward and creating some bridgehead positions. By 1904, the ring had received additional forts, which included the armoured forts of Wavre, Ste Catherine and Stabroeck and were no longer made of brick and earth. In 1906, the government approved the construction of additional forts to expand the position into the ‘Hoofdweerstandstelling’ or Main Defence Position with an outer ring of new forts about 20km from Antwerp that formed a semi-circle about 95km in long. In 1914, it was almost complete and included eleven armoured forts and twelve redoubts. These new fortifications, like many of the older ones and unlike those at Namur and Liège, had wet moats. Since reinforced concrete was not used, the walls and roofs could only resist 210mm weapons that did not use high-explosive shells.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("As the French initiated a revolution in artillery when they developed the high-explosive shell in the mid-1880s, the Belgian king was forced to recall Brialmont. The rifled cannons of the late 1850s and after fired shells at a higher velocity and greater accuracy than ever before and turned brick forts into rubble during the American Civil War. This put exposed positions like the reduits of Brialmont’s new forts at Antwerp at risk. In 1887, Brialmont tested the new high-explosive shell in firing trials against a structure built at the site of Brasschaat (later made into a fort). As a result, the government finally accepted in 1887 his proposal for two fortified bridgeheads at Liège and Namur consisting of fortress rings of detached concrete forts able to resist both German 210mm and French 220mm cannons."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn-12",
      "id": "fn-12"
    }
  }, [_vm._v("12")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f004-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The arms race that took place after the Franco-Prussian War and finally led to war included fortifications. Brialmont’s new fortresses of Liège and Namur, begun in 1888, neared completion by 1892. Unfortunately, his concrete forts were unable to resist the new generation of artillery developed in the 1890s. For Liège and Namur, he designed polygonal and triangular forts with a surrounding dry ditch protected by coffre (counterscarp casemates) and revetted scarps and counterscarps. These forts consisted of a central massif with a concrete citadel for the artillery turrets. The massif included infantry positions surrounding the citadel. Smaller disappearing turrets for 53mm or 57mm QF guns protected the corners of the massif. The forts had German Grüson turrets of special chilled iron, except for the steel turrets for Nordenfelt 57mm Mle 1888 QF guns. Most turrets mounted one or two guns, either Krupp 150mm Mle 1886 or 120mm Mle 1889 cannons. Another type had a single Krupp 210mm Mle 1889 and 1891 howitzer. The caponiers of the fossé received Cockerill/Krupp 57mm Mle 1888 QF guns. The gorge included casemate positions for facilities such as kitchens, latrines, barracks, etc. These forts did not have vulnerable reduits like those of the Antwerp girdle and none of their artillery occupied exposed positions on the walls. Like many contemporary military architects, Brialmont believed that concrete with added earthen protection could resist cannons leaving the forts only exposed to mortars and howitzers no larger than 210mm. He did not know that the Germans would develop the huge fort-busting Mörsers.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f005-1.jpg"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The critical flaw of Brialmont’s forts lay in the method of pouring concrete. Construction crews could only pour concrete in daylight hours, which produced successive layers of concrete rather than a solid uniform mass. As a result, heavy bombardment fractured the layers. In addition, the Belgian concrete mixture was not as strong as the one used by the Germans or French who poured a single continuous layer. In addition, the concept of reinforced concrete came into use after the completion of his forts and it was not used even in the few new forts of Antwerp of the early 1900s. Whereas the French added concrete to many of their older forts, the Belgians considered it too expensive.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Brialmont shopped around for artillery and armoured turrets. In the 1880s, after he carried out tests in Romania for which he had designed defences, he concluded that the German turrets were the best available, but he finally opted for a mixture of French and German turrets and even used some Swedish guns in his forts. At this time, Belgian industry did not produce heavy artillery or turrets. It wasn’t until early in the next century that the Belgian Cockerill Company, located at Seraing south-west of Liège, began producing turrets for some of Antwerp’s forts."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn-13",
      "id": "fn-13"
    }
  }, [_vm._v("13")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The casemate guns of some early Belgian forts had no recoil braking system, which meant that they hit the back wall when they recoiled. To remedy this problem, a metal plate was installed to protect the concrete wall from damage. The coffres that covered the fossé housed QF guns that used canister rounds for a shotgun effect. At the end of the ditch, opposite these guns, there were one or two alcoves in the counterscarp filled with sand to absorb hits and prevent damage to the masonry. Although they were effective against infantry attack, these forts were unable to resist the new German heavy artillery, which could pound them into dust in 1914.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1914: First Duel between Fortresses and Siege Artillery")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("When the Great War began, most of the Belgian army took up positions well behind the Meuse in preparation for holding a line along the Gette River to shield Brussels and the National Redoubt of Antwerp while two divisions held Liège and Namur.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the 1880s, Helmuth von Moltke the Elder ordered the development of new and more powerful weapons to replace the old 210mm Mörser that Brialmont’s forts were designed to resist. In 1899, German artillery battalions received the steel 210mm Mörser with a range of 7,000m. By July 1914, the army had 256 of the new siege guns and shortly afterward, the 210mm Mörser L/12, with a range of 9,000m."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn-14",
      "id": "fn-14"
    }
  }, [_vm._v("14")])]), _vm._v(" A more devastating weapon – designated the 305mm Küstenmörser (coastal mortar) – had already appeared in 1897. It was similar to the coastal mortars used in other countries and the American 12in mortar but had little chance of hitting a moving warship. Unlike the foreign versions, the German 305mm Mörser L/8 could be broken down and transported to the battlefield. Its range of over 8,000m was slightly greater than the artillery of the Belgian forts. It retained the name of Küstenmörser to lull the enemy’s suspicions. A further modified design, the 305mm Schwerer (heavy) Küstenmörser 09 model was able to penetrate 300mm of armour at a range of over 11,000m. In August 1914, only one battery was ready because few Mle 09 models had been produced. While the Mle 09 took five railway cars to move, the older model took only three. Steam tractors could move either model short distances by road. The Germans’ actual secret weapons were two versions of a 420mm weapon that included the Gamma Gun, which required a standard railway and six cars to move. Its range was 14,000m and it fired"), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _vm._v(" a projectile of 1,160kg, more than twice the size of the 305mm Beta mörsers’ 410kg round. The ‘Big Bertha’ 420mm M-Gerät was smaller and could also be moved by road or rail. It fired an 800kg round up to a range of 9,300m and required five horse-drawn wagons or a steam tractor to move. They were, in fact, the real fort busters. However, only two were ready in August 1914 and came directly from the testing grounds.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The 250mm Minenwerfer, a siege mortar used by army engineers, had to be emplaced within 600m of the target. Since it was a low-velocity weapon, its round had a thinner shell than similar ones for cannons and mörsers, which allowed it to hold more explosive. Thus, on August 1914, the Germans were ready after failing to take the fortress of Liège by a coup de main.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Belgians made desultory preparations until the Germans actually crossed their border on 3 August 1914. To complicate matters, the industrial city of Liège had expanded around the forts, blocking their fields of fire. On 3 August, Belgian troops knocked down houses and cleared vegetation, which the fortress commanders had been forbidden to do at the end of July in order to avoid giving the Germans an excuse to invade. The preparation of the interval positions between the forts had not started until 1 August, giving the army little time to do the job.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Some weaknesses of the Brialmont forts included the latrines, kitchen and food stores, which, located in the counterscarp casemates of the gorge, were exposed to enemy plunging fire. The windows of the gorge barracks had armoured shutters that failed to stand up to bombardment. Ventilation was far from adequate and the forts were not very hygienic. Interior lighting and searchlights were powered by a 20hp gas generator. The turrets’ manual ventilators were inadequate for the removal of smoke from the black-powder charges and did not prevent gases emanating from exploding shells from permeating the air. Few of the forts had electric generators. Observation for the forts’ artillery was a problem. The searchlight turret doubled as an observation post while other posts were outside the forts. Newly-strung overhead lines connected the forts to a central exchange in the city. When the war began, observation posts were set up in church steeples and other advantageous positions. Telephone lines linked them to the forts. All the turret guns, except for the 57mm QF guns, had slow-firing weapons that used black powder, the smoke from which masked observation from the fort. The maximum range of the 150mm and 120mm artillery was 7,500m to 8,500m"), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn-15",
      "id": "fn-15"
    }
  }, [_vm._v("15")])]), _vm._v(" and was no match for the newer German siege artillery. Except for the single 210mm howitzer turret in each fort, all the weapons had a flat trajectory and could not reach the German Mörsers and Minenwerfers that fired from masked positions. As Terrance Zuber points out, these more than two decades-old Belgian weapons had never been test fired and their range tables had never been verified.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The garrisons of the six large forts of Liège numbered up to 300 artillerymen and 200 infantrymen, while the six smaller ones had about 230 artillerymen and 100 infantrymen."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn-16",
      "id": "fn-16"
    }
  }, [_vm._v("16")])]), _vm._v(" Few of these troops were regulars and most were older local reservists. In addition to these 5,000 fortress troops, there were 23,000 men of the 3rd Division in Liège and over 160,000 civilians. Both Liège and Namur included four fortress infantry regiments and old reservists in the intervals. At Liège, many interval positions were still incomplete and fields of fire were not yet cleared before the Germans turned up."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn-17",
      "id": "fn-17"
    }
  }, [_vm._v("17")])]), _vm._v(" The garrisons burned their wooden barracks and moved into the forts. Although the field army had some MG units, the fortress regiments and forts did not have any."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn-18",
      "id": "fn-18"
    }
  }, [_vm._v("18")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When General Gerard Leman (1851–1920), commander of the 3rd Division, took charge of Fortress Liège in February 1914, he found the situation deplorable. Except for the Krupp 75mm guns with smokeless powder, his mobile artillery, like that of Fortress Namur, consisted of 114 obsolete weapons that included guns dating from 1862. In addition, limited ammunition made it impossible for him to provide effective counterbattery fire.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Facing Leman was General von Emmich’s X Army Corps of over 25,000 men and the II Cavalry Corps. On the night of 3/4 August, the Belgians blocked the railway tunnels at Hombourg, Nasproue, Trois-Ponts and Stavelot. The Germans did not reopen them and the main railway lines from Aachen to Liège until 18 August."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn-19",
      "id": "fn-19"
    }
  }, [_vm._v("19")])]), _vm._v(" On 4 August, the German cavalry raced to seize the bridge at Visé, but it was blown up before they arrived. There would be no coup de main. The Germans quickly moved their siege artillery into position, set up the 210mm Mörsers within 4,500m of Forts Pontisse and Barchon and opened fire on 5 August. The Belgian 3rd Division cleared the Germans from a position near Fort Barchon. A poorly coordinated assault on the night of 5/6 August against Fort Boncelles failed as canister from the 57mm QF gun turrets drove the Germans back. By the next morning, five of the six German brigades of the X Corps needed to be reformed. General Leman ordered the 3rd Division to withdraw from Liège and he abandoned the right bank of the Meuse, leaving the forts on their own. As German troops entered Liège, he moved his own headquarters into Fort Loncin. Further down the Meuse, the 4th Division withdrew from Namur and reached Hannut the next day after losing half its troops. Like those of Liège, the forts of Namur were left on their own."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn-20",
      "id": "fn-20"
    }
  }, [_vm._v("20")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f008-1.jpg"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Germans systematically reduced the Liège forts with six 210mm Mörsers attached to two of the German brigades while the heavier siege artillery was still en route. Most of the other twenty-six 210mm Mörsers arrived on 12 August. On 8 August, Fort Barchon became the first victim of these weapons; it was followed by Fort Evegnée on 11 August and three additional forts – including Fort Chaudefontaine and Fort Embourg – fell on 13 August. A battery of 305mm Beta Mörsers arrived in time to join the bombardment of Chaudefontaine, which surrendered after it was heavily damaged by a hit from a 210mm Mörser. On 12 August, the 420mm M-Gerät ‘Big Berthas’ finally arrived and went into action. The next day, they pounded Fort Pontisse, causing its surrender by noon. On 14 August, Forts Fléron and Fort Liers fell after four new 250mm Minenwerfers dropped their heavy shells on them. Fort Fléron sustained heavy damage to the gorge and surrendered later in the morning after the 210mm Mörsers opened a deadly new barrage. Fort Liers capitulated that afternoon. Fort Boncelles and Fort Lantin yielded on 15 August. That afternoon and later in the day, Fort Loncin became the target of the 420mm battery. A shell penetrated its superstructure and detonated in a magazine, wreaking havoc on the entire fort. General Leman was pulled from the rubble and taken prisoner when the fort fell. In the morning of 16 August, both Forts Hollogne and Flémalle, whose garrisons, having witnessed the destruction of Loncin, had little fight left in them, surrendered. The 210mm Mörsers had eliminated nine of twelve forts.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The iron-tipped, armour-piercing shells of the German siege guns penetrated the concrete citadels of Brialmont’s forts before detonating and fracturing ceilings, breaking pipes and knocking out power. The explosions filled the galleries with fumes as harmful as poison gas and blew out the lights, filling the air with dust. Rounds hitting turrets inflicted serious damage while the explosions from the near misses produced fumes that leaked into the poorly ventilated turrets. Since the defenders did not dare cross the gorge to reach the latrines during continuous bombardments, the stench of human waste pervaded the citadels. Morale dropped quickly, causing some forts to surrender without suffering major damage. Thus, the Belgian forts failed because of poor construction, equipment and antiquated weaponry. The blame for the defects belongs partially to Brialmont and partially to the Belgian government’s parsimony. Thus, Fortress Liège failed to delay the German offensive and the sabotaged lines of communication were soon restored.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After Fortress Liège fell in less than a fortnight, the German siege artillery moved on to the nine forts of Namur. The battery of two ‘Big Berthas’ and two batteries of 210mm Mörsers took up positions as they were reinforced by eight 305mm M.11 Skoda Mörsers on loan from Austria. On 20 August, the Germans were ready for the siege. The next day, they bombarded Forts Marchovelette and Andoy. The next day, the two 420mm M-Geräts pounded Fort Marchovelette. The Austrian guns fired on Forts Cognelée and Maizeret. On 23 August, Fort Cognelée surrendered. Shortly after that, Fort Marchovelette took a devastating hit from a 420mm round with similar results to Fort Loncin. Next, the Germans turned their heavy siege artillery on Fort Maizeret, quickly eliminating it. After Namur fell, the remaining six forts were reduced on 24 and 25 August beginning"), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _vm._v(" with Fort Andoy, which was smashed by the 305mm rounds. Fort Sarlée became a victim of the ‘Big Berthas’ and another fort gave up before it came under fire. Thus, the siege lasted less than a week.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Next, their siege artillery moved on to tackle several French forts. After the German offensive was blunted at the battle of the Marne in September, the siege artillery moved against Fortress Antwerp, its thirty-five forts and seven Belgian divisions. On 18 September, the Germans trained their two huge 420mm Gamma guns and a pair of 305mm Beta 09 Mörsers on Fort Wavre-Sainte-Catherine and Fort Waelhem. On 28 September, the 305mm Austrian Skoda opened up on Fort Koningshooikt; the next day, a battery of two ‘Big Berthas’ fired on Fort Lierre. Although the Antwerp forts put up a stronger resistance than those of Liège, they were soon turned into rubble and surrendered under the heavy bombardment. Hits on magazines destroyed two of the forts; others simply crumbled, forcing the Belgian troops to abandon their outer ring of defences. On 4 October, Fort Kessel, the most modern of the Antwerp forts, was destroyed in a single day. Fort Broechem lasted two days after 305mm and 420mm weapons went into action on 6 October and was abandoned like Kessel. On 9 October, Fort Breendonk, the last to fall, surrendered after resisting for three days. The German heavy artillery usually stayed beyond the range of the guns of the Belgian forts. Antwerp surrendered on 10 October after a siege of 12 days. The remnants of the Belgian army retreated to the coast to continue fighting. Thus, the three Belgian fortresses were eliminated in a period of two months."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn-21",
      "id": "fn-21"
    }
  }, [_vm._v("21")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent-1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Restoration of the Old Forts between the Wars")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Belgium incurred heavy losses in the Great War. After the Armistice, a 20,000- man Belgian occupation force set up headquarters in Aachen to control the left bank of the Lower Rhine Valley. In January 1925, they joined the French for several months in the occupation of the Ruhr. The occupation of the Rhineland ended in 1930. Belgium continued its alliance with France and prepared for a German resurgence. The first steps were the evaluation and restoration of the forts of the three fortress rings.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("During the war, the Germans had transformed the forts of Liège into infantry support points by adding trenches, concrete shelters, blockhouses and infantry exits reinforced with outer concrete walls and armoured doors that included small-arms embrasures. They reduced the number of windows, leaving only enough for proper ventilation. They improved the entire ventilation system, added modern power generators, repaired damaged concrete sections and salvaged turrets and weapons for scrap. Latrines were placed in the scarp near the ventilators."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn-22",
      "id": "fn-22"
    }
  }, [_vm._v("22")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In 1927, a new commission sent recommendations to Minister of Defence Broqueville for rearming some forts with machine guns to replace the artillery turrets and for mounting a couple of 105mm howitzers in the gorge coffres. Other proposed changes included the creation of troop shelters with concrete walls 4m thick inside the forts and the modification of access to the forts. Although the Germans had scrapped most of the turrets, four of the Liège forts on the right bank still had them. The army decided to rearm them with German guns while four other forts to be restored would receive 75mm howitzers. Fort Loncin and another badly-damaged fort on the left bank were not restored. The reconstruction work began in 1929.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The area beneath the central massif of the forts underwent major modifications that included an improved ventilation system and a protected subterranean "), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _vm._v("entrance. At Liège and Namur, 150mm cannon with a range of 18,000m replaced the 210mm turret howitzers. Turrets with 105mm guns with a range of 12,000m replaced the 120mm cannons. A 75mm howitzer replaced the 57mm QF gun in the small eclipsing turret. Pairs of reversible machine guns with two to four lance-grenade – special projectors, similar to mortars that launched 120mm ‘winged Mills grenades’ for close defence – replaced the 150mm guns of the centrally-located turret."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn-23",
      "id": "fn-23"
    }
  }, [_vm._v("23")])]), _vm._v(" Observation cloches, most of which could mount a fusil mitrailleur (FM – automatic rifle) replaced the searchlight turret and MGs. Finally, FMs replaced 57mm QF guns in casemates and coffres to defend various sections of the fort such as casemates and coffres.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In addition to equipping their forts with more modern and longer-range weapons, the Belgians filled in some subterranean rooms and excavated a deeper tunnel system for increased protection. The new galleries formed a quadrangle and led to access points to turrets and coffres. The German modifications were kept because they gave the infantry better access to the fossé and the surface. The German use of corrugated iron on tunnel ceilings was continued. Reinforced concrete was added to concrete and brick walls. Exits now included airtight armoured doors and decontamination rooms for protection against gas. Air intake towers shaped like water towers built about 300m to 350m from each fort included defensive positions and were connected to the forts by a tunnel. Communications improved with underground telephone lines and a radio room in each fort. Electric spotlights to cover the fossé and the entrance replaced the searchlights. The old forts underwent most of these modifications by 1932; their rearmament and occupation had been completed by 1935. Anti-tank rails were added to the glacis in 1936. However, in 1939 another commission found persisting problems with ventilation and the new airtight doors.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("However, not all the old forts were restored. For instance, less effort was put into the renovation of the Antwerp forts where MG positions replaced many of the turrets. The work on a bridgehead at Ghent (Gand), which was intended as a final bastion, had to be postponed."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn-24",
      "id": "fn-24"
    }
  }, [_vm._v("24")])]), _vm._v(" Some of the remaining components from the turrets of Antwerp, such as the avant-cuirasse, were sent to the forts of Liège and Namur."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn-25",
      "id": "fn-25"
    }
  }, [_vm._v("25")])]), _vm._v(" A massive anti-tank (AT) ditch was dug along the eastern front at Antwerp. It was mostly water filled and large bunkers were built into it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The weapons used in the forts included the 75mm L/11 howitzer with a range of 5,200m (canister range was 250m) for the eclipsing turrets built at Belgium’s Fonderie Royale des Canons. The 105mm L/135 cannons had a range of 13,000m and could fire three rounds a minute for short periods of time. The 150mm L/40 had a range of 18,000m; its turret, unlike the others, was powered electrically. The 150mm gun turrets were produced by Creusot et Vandekerhove and Saint- Chamond et Cockrill."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn-26",
      "id": "fn-26"
    }
  }, [_vm._v("26")])]), _vm._v(" The water-cooled 7.65mm Maxim 08/15 machine guns with a range of 2,000m came from the Belgian Manufacture d’Armes de l’Etat. The FM was a Model 1930 manufactured at the Fabrique Nationale at Herstal.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Preparing a Line of New Forts")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The early withdrawal from the Rhineland in June 1930 pushed the Belgian government to take action. At the end of 1932, it approved plans for new forts and a Position Fortifée de Liège (PFL) in advance of the line of the restored forts. The old line became PFL 2. Work on the new PFL began in April 1933. Construction on Fort Eben-Emael had already started in December 1932."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn-27",
      "id": "fn-27"
    }
  }, [_vm._v("27")])]), _vm._v(" The new line ran from the vicinity of Visé for about 60km across the Herve Plateau, "), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _vm._v("which extended from the edge of the Meuse Valley to the German border. The government only funded four new forts for the six selected sites."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn-28",
      "id": "fn-28"
    }
  }, [_vm._v("28")])]), _vm._v(" These new forts, which somewhat resembled the French Maginot Line ouvrages, were completed, armed and garrisoned between 1935 and 1939. They included the two small forts of Neufchâteau and Tancrémont and the large fort of Battice. Fort Eben-Emael, the other large fort, was given priority because it overlooked the new Albert Canal and blocked access from the Maastricht Appendage of the Netherlands in the event the Germans tried to outflank the defences of Liège. These new forts covered larger areas than their predecessors did. Reinforced concrete and deep subterranean galleries made them largely bombproof. Each fort, except Eben-Emael, had two main entrances: a wartime entrance behind the fort connected by a tunnel and a peacetime entrance in the surrounding fossé. The subterranean facilities included a caserne, a usine, magazines, filter rooms, command posts and a communications room. An underground caserne outside the fort was located beneath the peacetime barracks. The forts had a gas-proof ventilation system. Each fort’s artillery turret mounted two 75mm guns. The large forts also had long-range artillery in turrets for two 120mm guns. Eben-Emael had two additional casemates for three 75mm guns that covered the crossings of the Albert Canal and the Maas. Infantry positions included machine guns and AT guns. Some infantry casemates and coffres had spotlights. After the construction of the forts ended in 1936, King Leopold announced Belgium’s return to neutrality on 14 October.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f012-1.jpg"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f013-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Plan of Eben-Emael with fields of fire for close defence. Photos of the fort.")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f014-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Interval positions appeared between the forts of the PFLs and bunkers were added along some of the major canal lines that had been selected as defensive positions. Little of significance was built in the Ardennes and Luxembourg provinces.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Cloches were added to some interval positions in PFL 1; some were simple observation cloches and others one- and two-man types for weapons. Some used a lance fusée (flare gun). In 1936, the Belgian government purchased twenty-five APX-2B turrets from the French Ateliers du Puteaux company that had frontal and side armour 25mm thick and mounted a 47mm Mle FRC 1936 cannon and a Hotchkiss 7.64mm machine gun. Two of these turrets were installed on an abri at Sougné-Remouchamps at the site of the cancelled fort."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn-29",
      "id": "fn-29"
    }
  }, [_vm._v("29")])]), _vm._v(" Thirteen more were placed on coastal bunkers. The standard abri for PFL 1 was 7 × 4.6m and had reinforced concrete walls 1.3m thick capable of resisting 150mm rounds. On the Herve Plateau of the main line, there were 178 standard abris and more complex bunkers. The advanced position in front of the main line had sixty-five additional such positions and PFL 2, sixty-two more. PFL 3 and PFL 4 combined had seventy-eight.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent-1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("The New Forts")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The building of Eben-Emael, the showcase of the Belgian defences, began after construction started on the Albert Canal in 1930. The canal – finished in 1939 – linked Antwerp with Liège and included a 65m deep and 1,200m long, cut through St. Peter’s Hill that connected it with the Meuse. Its west side was an excellent defensive position and held bunkers along its entire line.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f015-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Photos of 60mm anti-tank gun in Battice.")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f015-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Photo of searchlight in Battice casemate with light turned inside. Photo of searchlight casing which rotated the light into embrasure and rotated to close crenel.")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f016-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Reversable machine-gun mount: the gun on top is in the firing position. When it gets too hot, the entire assembly rotates placing it in the bottom position and the second machine gun in the firing position. Top right: shows the ball mount with its opening for the weapons sight and the opening for the machine gun. Top left: identifies the parts of the mount which can be viewed on the bottom photo.")]), _vm._v(" (Photos courtesy of Andreas E. Schröder)")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Eben-Emael was shaped like a pie slice. Its northern end formed the apex of the triangle and the canal served as a moat. A wet ditch ran along part of the north-west side. The west and south sides dropped off, giving the fort an elevation of about 60m above ground level. The entrance block on the west side included relatively standard features. It led to the lowest gallery, which included the caserne, the usine with six diesel engines, the infirmary, storerooms and the main ventilation system. The central stairway and elevator accessed the intermediate level, 20m above (or 40m below the surface of the fort) with 4km of tunnels and galleries and gave access to all the other blocks. All the artillery blocks included munitions magazines at this level and access by both lift and stairs. The main air intakes consisted of two large ventilators on the canal wall side. Toward the centre of the fort, a large armoured dome served as a chimney that removed foul air. Filter rooms cleaned the air in case of gas attack. The entrance and exits had decontamination areas and hermetically-sealed doors. Inside the entrance, a rolling bridge in front of an armoured door blocked access to the interior. The other forts had similar features.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The close-defence weapons included German Maxim 08/15 water-cooled machine guns adapted for Belgian ammunition that were usually on two-gun reversible mounts. The Belgian FM-30 was also used. Blocks on the perimeter had Belgian 60mm Mle 36 FRC AT guns (the two smaller forts used 47mm AT guns). The artillery consisted of the 75mm GP (Grande Portée – long range) cannon. Eben-Emael’s four three-gun artillery casemates housed a modified 1905 Krupp gun with a range of up to 11,000m. The 75mm turret guns were FRC Mle 1934 built under licence from Bofors. The FRC 120mm Mle 1931 turret guns had a range of 17,000m.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Of Eben-Emael’s four 75mm gun casemates, Ma 1 and Ma 2 covered the canal bridges at Vroenhoven and Veldwezelt while Vi 1 and 2 covered the Maas locks in the direction of Visé. The infantry blocks had machine guns and 60mm AT guns. Two blocks at canal level, each of two levels, included the same weapons as infantry blocks and searchlights to illuminate a night crossing. A few infantry blocks and the entrance block that mounted searchlights were located in the scarp. A tunnel linked an additional infantry and observation block along the canal to the fort. Some blocks had exits to the surface, but the garrison did not include infantrymen. There were positions for a few AA machine guns near a couple of those exits. The 1,200-man garrison used a temporary peacetime barracks."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn-30",
      "id": "fn-30"
    }
  }, [_vm._v("30")])]), _vm._v(" At the time of the German attack, improvements on the ventilation and communications systems were in progress. Morale among the troops was low.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f017-1.jpg"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f018-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Dummy 120mm gun turret.")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f018-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Cloche for FM")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f018-3.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Barracks and galleries beyond the Entrance Block")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f018-4.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("75mm gun turret")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f018-5.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Two photos show Rolling (or sliding) bridge of Entrance Block open and almost completely retracted.")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The fort’s reinforced concrete and armour was expected to resist 420mm weapons. The walls of the combat blocks were 2.2m thick and roofs, 2.25m. Those of the two canal blocks were 3m thick. Turret armour thickness varied from fort to fort. The 75mm turrets were up to 380mm thick. The 120mm turret, on the other hand, consisted of 210mm over another 250mm layer of nickel steel. At Battice, the armour was thicker because it was more vulnerable to enemy artillery and the "), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }), _vm._v("concrete for its turret blocks was 4.5m thick compared to Eben-Emael’s at 3.0m and those of Aubin-Neufchâteau and Tancrémont were up 3.5m. Battice’s infantry blocks were 3.5m thick and those of the two smaller forts were 3.2m thick while those of Eben-Emael’s were 2.75m thick. All four forts had similar features in their caserne: gas protection, decontamination areas, armoured doors, etc.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Although two-thirds the size of Eben-Emael, Battice, built between 1934 and 1937, was the strongest of the Belgian forts. It had thirteen blocks to Eben-Emael’s seventeen and a garrison of 900 men. Its exposed walls and roofs were intended to resist 520mm rounds with a 3.5m concrete thickness. Its gallery level was 30m below the surface. Battice, located 17km from the border, blocked the direct route from Aachen, but was within range of German heavy artillery.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In early 1935, construction began on Forts Aubin-Neufchâteau and Tancrémont. The former’s 75mm guns could not reach Eben-Emael, but covered Battice. Tancrémont’s 75mm gun range was just short of reaching Battice. The forts of PFL 2 could cover all three forts. Both forts were designed to resist 420mm rounds and their artillery blocks had a ceiling thickness of 4.5m and walls of 3.5m. Both of these forts had moats 15m wide and 5m deep. Both included a block for 81mm mortars.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When the German offensive in the West opened on 10 May 1940, Eben-Emael fell to a glider assault. The other forts of Fortress Liège put up a fight. Battice surrendered on 22 May and Tancrémont not until 29 May, a day after the king capitulated. Most of the forts of PFL 2 had already fallen. The forts of Namur had fallen by 23 May."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn-31",
      "id": "fn-31"
    }
  }, [_vm._v("31")])])]), _vm._v(" "), _c('p', {
    staticClass: "footnotet"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn-1",
      "id": "rfn-1"
    }
  }, [_vm._v("1")]), _vm._v(". These plains include Flanders - the Dutch-speaking part of Belgium from which the term Flemish is derived - and extend south to the Meuse between Namur and Liège (Luik in Dutch and Lüttich in German).")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn-2",
      "id": "rfn-2"
    }
  }, [_vm._v("2")]), _vm._v(". De Broqueville held several offices including Prime Minister, Minister of the Interior and Minister of Defence between 1911 and 1934. He was the Prime Minister during the First World War.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn-3",
      "id": "rfn-3"
    }
  }, [_vm._v("3")]), _vm._v(". Brialmont designed fortifications for Belgium’s three major cities in the latter half of the nineteenth century and, at the same time, created the defences of Bucharest in Romania in the 1880s. He also wrote several books on artillery and fortifications. He was considered the authority on polygonal fortifications, armoured artillery and concrete fortifications. However, his work was becoming obsolete by the end of the century (Rolf, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Dictionary on Modern Fortification")]), _vm._v(", p. 59).")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn-4",
      "id": "rfn-4"
    }
  }, [_vm._v("4")]), _vm._v(". Montalembert, called the ‘father of modern fortifications’, saw the siege as an artillery duel and called for a ‘perpendicular fortification’ whose artillery would no longer be exposed on the ramparts but be protected by casemates in rows and tiers. He also proposed replacing Vauban’s bastioned forts with polygonal forts. His ideas would dominate nineteenth-century military architecture (Hogg, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("History of Fortification,")]), _vm._v(" p. 131). In "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("La Fortification a Fossés Secs")]), _vm._v(", Henri Brialmont expounded upon Montalembert’s ideas by comparing Vauban’s bastion trace to Montalembert’s polygonal design demonstrating the advantages. The Crimean War and the siege of Sebastopol underlined the need for change in face of the new artillery.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn-5",
      "id": "rfn-5"
    }
  }, [_vm._v("5")]), _vm._v(". This was a series of fortifications created after the Napoleonic Wars to protect the Netherlands, which included Belgium at the time, from invasion (Kaufmann, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Neutral States")]), _vm._v(", pp. 82-3).")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn-6",
      "id": "rfn-6"
    }
  }, [_vm._v("6")]), _vm._v(". In 1888, Deguise (1855-1922) became Professor of Fortifications at the Military Academy and in 1909-11 he was Commandant of Engineers at Brussels. In 1911, he became Director of the 3rd Military District responsible for fortifications and in 1914, he became Military Governor of Antwerp and conducted its defence until October 1914.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn-7",
      "id": "rfn-7"
    }
  }, [_vm._v("7")]), _vm._v(". A Swedish inventor and diplomat, Martin von Wahrendorff (1789-1861) patented a breech mechanism, the Wahrendorff breech, in 1837. The Swedish army adopted three types of his smoothbore breech-loading guns. Austria-Hungary purchased many of his cannons, which he built at the Akers gun foundry near Stockholm, inherited from his father. His cannons were exported to the Netherlands, Britain, Spain, Denmark, Russia, Norway, Prussia and even the USA. In addition to his breech mechanism, he produced an advanced traversing carriage.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn-8",
      "id": "rfn-8"
    }
  }, [_vm._v("8")]), _vm._v(". A British naval officer, Cowper Coles (1819-70) designed turret ships in the 1850s and 1860s.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn-9",
      "id": "rfn-9"
    }
  }, [_vm._v("9")]), _vm._v(". The roof consisted of a thin sheet of metal.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn-10",
      "id": "rfn-10"
    }
  }, [_vm._v("10")]), _vm._v(". Brialmont published "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Situation Militaire de La Belgique")]), _vm._v(" in 1882 to expose Belgium’s vulnerability and gain support for his proposed Meuse forts. He was opposed by Hubert Joseph Walthère Frère-Orban (1812-96) since 1873 (Brialmont, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Situation Militaire de La Belgique")]), _vm._v(", pp. 62-78).")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn-11",
      "id": "rfn-11"
    }
  }, [_vm._v("11")]), _vm._v(". In addition to advising the Romanians in the late 1880s, Brialmont went to Bulgaria to design an entrenched camp for Sofia in 1891 after he had retired because the Belgian government refused additional funding for his forts. The Belgian government recalled him from Romania for fear of offending the Russians. The following year, the Turkish sultan asked him to prepare a proposal for the defence of the Straits. The sultan rejected his expensive proposals also out of fear of Russia. The Japanese invited him to design the defences for Tokyo, Osaka and Nagasaki (Mayer, ‘Brialmont’, pp. 184-6).")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn-12",
      "id": "rfn-12"
    }
  }, [_vm._v("12")]), _vm._v(". The cost of these fortifications would triple over the originally government-authorized sum and Brialmont still had to operate under financial restrictions (Coenen and Vernier, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("La Position Fortifiée de Liège")]), _vm._v(" Vol. 5, p. 6).")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn-13",
      "id": "rfn-13"
    }
  }, [_vm._v("13")]), _vm._v(". The Englishman John Cockerill established his company in Belgium in 1817. In 1867 it became the first Belgian manufacturer using the Bessemer process for steel production.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn-14",
      "id": "rfn-14"
    }
  }, [_vm._v("14")]), _vm._v(". It was deployed in four-gun batteries.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn-15",
      "id": "rfn-15"
    }
  }, [_vm._v("15")]), _vm._v(". Sources cite varying ranges.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn-16",
      "id": "rfn-16"
    }
  }, [_vm._v("16")]), _vm._v(". In the next war the Belgians created a problem by only using artillerymen.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn-17",
      "id": "rfn-17"
    }
  }, [_vm._v("17")]), _vm._v(". Permission to clear fields of fire was received on 2 August.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn-18",
      "id": "rfn-18"
    }
  }, [_vm._v("18")]), _vm._v(". The German and some other armies adopted the Maxim machine gun in 1909.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn-19",
      "id": "rfn-19"
    }
  }, [_vm._v("19")]), _vm._v(". The Stavelot tunnel was reopened on 8 August.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn-20",
      "id": "rfn-20"
    }
  }, [_vm._v("20")]), _vm._v(". See Zuber, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ten Days in August")]), _vm._v(", p. 178.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn-21",
      "id": "rfn-21"
    }
  }, [_vm._v("21")]), _vm._v(". Romanych and Rupp, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("42cm Big Bertha.,")]), _vm._v(" pp 34-6.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn-22",
      "id": "rfn-22"
    }
  }, [_vm._v("22")]), _vm._v(". Coenen and Vernier, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("La Position Fortifiée de Liège")]), _vm._v(" Vol. 5, pp. 11-12.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn-23",
      "id": "rfn-23"
    }
  }, [_vm._v("23")]), _vm._v(". Reversible machine guns consisted of two Maxims, one on top of the other. When one gun needed to cool down, it was lowered into the position of the bottom gun.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn-24",
      "id": "rfn-24"
    }
  }, [_vm._v("24")]), _vm._v(". To reassure the Walloons south of the Meuse, the Belgian government approved the construction of a few resistance centres in their region and the formation of the Chasseurs d’Ardennes in 1933. This unit soon became a division that included a few light tank companies. Its regiments were stationed at Arlon, Bastogne and Vielsalm. The 2nd Chasseurs Ardennais Division formed near Namur at the end of 1939.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn-25",
      "id": "rfn-25"
    }
  }, [_vm._v("25")]), _vm._v(". This was the case for three turrets at Boncelles, four at Flémalle and three at Pontisse. One turret at Chaudefontaine and two at Embourg received the avant-cuirasse from Hollogne (see Coenen and Vernier, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("La Position Fortifiée de Liège")]), _vm._v(" Vol. 5, p. 72).")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn-26",
      "id": "rfn-26"
    }
  }, [_vm._v("26")]), _vm._v(". The French Creusot, St. Chamond and Chatillon & Commentry turrets were produced in cooperation with the Belgian companies of Vandekerchove, Cockerill, Marcinelle & Couillet and Ateliers de la Meuse.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn-27",
      "id": "rfn-27"
    }
  }, [_vm._v("27")]), _vm._v(". According to some sources, it was April 1932.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn-28",
      "id": "rfn-28"
    }
  }, [_vm._v("28")]), _vm._v(". Plans for Forts Mauhin and Les Waides were dropped and in 1934, a new site was picked at Aubin-Neufchâteau. In 1934, the government cancelled a fort for Sougné-Remouchamps to block the Amblève Valley on the south end of PFL 1.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn-29",
      "id": "rfn-29"
    }
  }, [_vm._v("29")]), _vm._v(". The remaining ten turrets went to tank chassis, also bought from France (Short, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Tank Turret Fortifications,")]), _vm._v(" pp. 32-5).")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn-30",
      "id": "rfn-30"
    }
  }, [_vm._v("30")]), _vm._v(". This was standard for forts of both World Wars.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn-31",
      "id": "rfn-31"
    }
  }, [_vm._v("31")]), _vm._v(". Since this work can only include a limited amount of information for each country, we recommend our "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Forts & Fortifications of Europe: The Neutral States")]), _vm._v(" for additional details on the forts and their history during both World Wars.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-057d52d5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/08_Chapter01.vue
// module id = 81
// module chunks = 0